import React from 'react'


export default function Divider() {
    return <div className="h-px w-full border-b border-gray-300" />
}
